import { apiFetch } from "./client";

export type ForecastStatus = "DRAFT" | "SUBMITTED";

export type ForecastLine = {
  productId?: string | null;
  freeText?: string | null;
  quantity: number;
  unit: string;
  notes?: string | null;
};

export type Forecast = {
  id: string;
  companyId: string;
  companyName: string;
  periodYear: number;
  periodQuarter: number | null;
  periodMonth: number | null;
  status: ForecastStatus;
  forecastLines: ForecastLine[];
  notes: string | null;
  createdBy: string | null;
  submittedAt: string | null;
  createdAt: string;
  updatedAt: string;
};

const q = (params: Record<string, string | undefined>) => {
  const usp = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => v && usp.set(k, v));
  const s = usp.toString();
  return s ? `?${s}` : "";
};

export const forecastsApi = {
  list: (params: { companyId?: string } = {}) => apiFetch<Forecast[]>(`/forecasts${q(params)}`),
  get: (id: string) => apiFetch<Forecast>(`/forecasts/${id}`),
  create: (body: {
    companyId: string;
    periodYear: number;
    periodQuarter?: number;
    periodMonth?: number;
    forecastLines?: ForecastLine[];
    notes?: string;
  }) => apiFetch<Forecast>("/forecasts", { method: "POST", body }),
  update: (id: string, body: { forecastLines?: ForecastLine[]; notes?: string }) =>
    apiFetch<Forecast>(`/forecasts/${id}`, { method: "PUT", body }),
  submit: (id: string) => apiFetch<Forecast>(`/forecasts/${id}/submit`, { method: "POST" }),
  delete: (id: string) => apiFetch<void>(`/forecasts/${id}`, { method: "DELETE" }),
};

export function periodLabel(f: Forecast): string {
  if (f.periodQuarter != null) return `${f.periodYear} Q${f.periodQuarter}`;
  if (f.periodMonth != null) return `${f.periodYear}-${String(f.periodMonth).padStart(2, "0")}`;
  return String(f.periodYear);
}
